import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Lost & Found. /club/lostFound. {id}:{item,date,foundBy,returned,returnedTo,notes,photo,createdAt}
const BASE = 'club/lostFound'
const today = () => new Date().toISOString().slice(0, 10)

export function watchLostFound(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function createLostItem(d) {
  const item = String(d.item || '').trim(); if (!item) throw new Error('Item is required.')
  const node = push(tref(BASE))
  await set(node, { id: node.key, item, date: d.date || today(), foundBy: String(d.foundBy || '').trim(), returned: false, returnedTo: '', notes: String(d.notes || '').trim(), photo: String(d.photo || '').trim(), createdAt: Date.now() })
  logActivity({ type: 'lostfound', icon: '🧢', text: `Found item logged: ${item}` })
  return node.key
}
export async function markReturned(id, returnedTo) { await update(tref(`${BASE}/${id}`), { returned: true, returnedTo: String(returnedTo || '').trim(), returnedDate: today() }) }
export async function deleteLostItem(id) { await remove(tref(`${BASE}/${id}`)) }
